import { memo } from "react";
import { RosterColumnHoverBackdrop } from "@/components/nurse/nurseVerticalGrid";
import { cn } from "@/utils/cn";

export type RosterTableBodyChromeProps = {
  daysInMonth: number;
  hasPrevTail: boolean;
  /** CREATE `compactVerticalPadding` 과 동일 */
  compactVerticalPadding?: boolean;
  children: React.ReactNode;
};

/** 근무표 만들기·발행 조회 공통: 카드 테두리 + 열 호버 백드롭 */
export const RosterTableBodyChrome = memo(function RosterTableBodyChrome({
  daysInMonth,
  hasPrevTail,
  compactVerticalPadding = false,
  children,
}: RosterTableBodyChromeProps) {
  return (
    <div className="rounded-lg relative">
      <div
        className={cn(
          "relative z-[1] border border-border rounded-lg",
          compactVerticalPadding ? "p-0" : "p-0 py-2"
        )}
      >
        <RosterColumnHoverBackdrop
          daysInMonth={daysInMonth}
          hasPrevTail={hasPrevTail}
        />
        {children}
      </div>
    </div>
  );
});
